<template>
  <one-column-layout class="dark space-l">

    <title-bar title="Submissions"
               slot="titleBar"
               type="page"
               :action-menu="!isDesktop"
               @menu="toggleNav"
               >

      <div class="smd-spacer"/>
    </title-bar>

    <div class="toolbar" slot="subtitleBar">
      <smd-segment type="pill"
                   :items="$options.Views"
                   v-model="activeView"></smd-segment>

      <div class="smd-spacer"></div>

      <!--<template v-if="activeView === 'SubmissionCases'">-->
        <!--<smd-segment type="pill solid"-->
                     <!--:items="$options.Filters"-->
                     <!--v-model="activeFilter"/>-->

        <!--<smd-btn icon="smd-icon-action-share"/>-->
      <!--</template>-->
      <smd-btn
        v-if="activeView === 'SubmissionCases' && !isPackaging"
        pilled tiny class="icon-text"
               @click="createSubmission"
               >
        Create Package</smd-btn>
      <smd-btn
        v-if="activeView === 'SubmissionCases' && isPackaging"
        pilled tiny class="icon-text"
      >
        Packing...</smd-btn>

    </div>

    <router-view/>

  </one-column-layout>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import {
    ACTION_LOAD_CLOSED_CASES,
    ACTION_LOAD_ALL_CLOSED_CASES,
    ACTION_CREATE_CENSUS_PACKAGE,
    MUTATE_SET_SELECTED_CASES,
    GETTER_SELECTED_CASES,
    GETTER_ISPACKAGING
  } from "../../../store/modules/submissions";

  import Routes from '../../../router/route-constants'

  import uiHelper from '../../../mixins/uihelper'

  export default {
    name: "root-submissions",
    mixins: [uiHelper],
    data(){
      return{
        activeView   : 'cases',
        activeFilter : 'maternalFetalForm'
      }
    },
    computed: {
      ...mapGetters({
        selectedCases: GETTER_SELECTED_CASES,
        isPackaging: GETTER_ISPACKAGING
      }),
      isDesktop(){
        return this.$mq.desktop;
      }
    },
    methods: {
      ...mapMutations({
        setSelectedCases: MUTATE_SET_SELECTED_CASES
      }),
      createSubmission(){
        this.$toasted.show("Building Package...");
        const data = {selectedCases: Object.keys(this.selectedCases)};
        if(data.selectedCases < 1){
          this.$toasted.show('No selected cases');
        } else if (this.isPackaging) {
          this.$toasted.show('Still processing previous package');
        } else {
          this.$store.dispatch(ACTION_CREATE_CENSUS_PACKAGE, data)
            .then(result => {
              this.$store.dispatch(ACTION_LOAD_ALL_CLOSED_CASES)
                .then(()=>{
                  this.$toasted.show('Census Package has been successfully created!');
                  this.setSelectedCases([]);
                  this.activeView = Routes.ROUTE_SUBMISSION_CENSUS;
                  this.$router.push({name: Routes.ROUTE_SUBMISSION_CENSUS});
                })
            })
        }
      }
    },
    Views: [
      {val: Routes.ROUTE_SUBMISSION_CASES   , label: 'Cases'},
      {val: Routes.ROUTE_SUBMISSION_CENSUS  , label: 'Census Packages'}
    ],
    caseTypes: {
      MATERNAL_FETAL_CASE:'maternalfetalcase',
      GYNE_CASE: 'gynecase',
      MATERNAL_MORTALITY_CASE: 'maternalmortalitycase',
      GTD_CASE: 'gtdcase'
    },
    Filters : [
      {val: 'maternalfetalcase'      , label: 'Maternal Fetal Form'},
      {val: 'gynecase'                , label: 'Gyne Form'},
      {val: 'maternalmortalitycase' , label: 'Maternal Mortality Form'},
      {val: 'gtdcase'                , label: 'GTD Form'}
    ],
    watch:{
      'activeView'(newRoute){
        this.$router.push({name: newRoute});
      },
      'activeFilter'(){
        const casetype = this.activeFilter;
        this.$store.dispatch(ACTION_LOAD_CLOSED_CASES, casetype)
          .then((data) => {
            this.$router.push({
              name: Routes.ROUTE_SUBMISSION_CASES,
              params: {casetype: this.activeFilter}
            });
          });
      }
    },
    mounted(){
      this.activeView = this.$route.name
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../scaffolding/scss/pogs-util';

  .icon-text {
    @include responsive(mobile) {
      font-size: 10px;
    }
  }
</style>
